import * as $ from 'jquery';

const scrollTopHideClass: string = 'scrollToTop--hide';

export function initScrollToTopButton() {
  const $scrollToTopButton = $('.js-scrollToTop');
  let documentElementScrolltop = 0;
  if ($scrollToTopButton.length) {
    $(window).on('scroll', () => {
      if (document.documentElement !== null) {
        documentElementScrolltop = document.documentElement.scrollTop;
      }

      if (document.body.scrollTop > 20 || documentElementScrolltop > 20) {
        $scrollToTopButton.removeClass(scrollTopHideClass);
      } else {
        $scrollToTopButton.addClass(scrollTopHideClass);
      }
    });

    $scrollToTopButton.on('click', () => {
      $('body, html').animate({scrollTop: 0}, 400);
    });
  }
}

export function initScrollToAnchor() {
  const $scrollToAnchorLink = $('.js-scrollToAnchor');
  $scrollToAnchorLink.each(() => {
    $scrollToAnchorLink.on('click', (event) => {
      const anchor = $(event.currentTarget).attr('href');
      scrollToAnchor(anchor?.split('#')[1]);
    });
  });
}

function scrollToAnchor(anchor) {
  $('html,body').animate({
    // @ts-ignore
    scrollTop: $('#' + anchor).offset().top - 100,
  });
}
